"use strict";

Node.prototype.on = function (eventName, selector, callback) {
  if (callback === undefined) {
    this.addEventListener(eventName, function (event) {
      selector.call(event.target, event);
    });
  } else {
    this.addEventListener(eventName, function (event) {
      for (var target = event.target; target && target !== event.currentTarget; target = target.parentNode) {
        if (target.matches !== undefined && target.matches(selector)) {
          callback.call(target, event);
        }
      }
    });
  }
};

Element.prototype.matchingParent = function (selector) {
  var element = this;

  for (; element && element !== document; element = element.parentNode) {
    if (element.matches(selector)) {
      return element;
    }
  }

  return null;
};

Element.prototype.toggleClass = function (className) {
  this.classList.toggle(className);
};

Element.prototype.setClass = function (className, shouldSet) {
  if (shouldSet) {
    this.classList.add(className);
  } else {
    this.classList.remove(className);
  }
};

Element.prototype.collapse = function () {
  this.classList.add("collapsed");
};

Element.prototype.expand = function () {
  this.classList.remove("collapsed");
};

Element.prototype.ariaShow = function () {
  this.setAttribute("aria-hidden", false);
};

Element.prototype.ariaHide = function () {
  this.setAttribute("aria-hidden", true);
};

window.dinDate = function (date) {
  var day = date.getDate();
  var month = date.getMonth() + 1;
  var year = date.getFullYear();

  if (day < 10) {
    day = "0".concat(day);
  }

  if (month < 10) {
    month = "0".concat(month);
  }

  return "".concat(day, ".").concat(month, ".").concat(year);
};

window.clone = function (obj) {
  return Object.assign({}, obj);
};

function initDatePicker(element) {
  return element.flatpickr({
    "locale": "de",
    "allowInput": true,
    "altInput": true,
    "altFormat": "d.m.Y",
    "dateFormat": "Y-m-d",
    "parseDate": function parseDate(date) {
      var parts = date.split(".");
      var result;

      if (parts.length === 3) {
        if (parts[2].length < 4) {
          parts[2] = 2000 + parseInt(parts[2]);
        }

        if (parts[1].length === 1) {
          parts[1] = "0" + parts[1];
        }

        if (parts[0].length === 1) {
          parts[0] = "0" + parts[0];
        }

        result = new Date(parts[2] + "-" + parts[1] + "-" + parts[0]);
      } else {
        result = new Date(date);
      }

      if (!isNaN(result)) {
        return result;
      }

      return undefined;
    }
  });
}

document.on("click", "#cookie-consent button[data-cookie-string]", function (event) {
  document.cookie = event.target.dataset.cookieString;
  document.querySelector("#cookie-consent").remove();
}, false);